import { createContext, ReactNode, useEffect, useMemo } from 'react'
import { SetURLSearchParams, useSearchParams } from 'react-router-dom'


interface SearchParamsContextType {
    searchParams: URLSearchParams,
    setSearchParams: SetURLSearchParams
}

export const SearchParamsContext = createContext<SearchParamsContextType | null>(null)

export const SearchParamsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [searchParams, setSearchParams] = useSearchParams()

    useEffect(() => {
        window.multistrikeChartManager?.setSearchParamsMethod(setSearchParams);
        return () => {
            window.multistrikeChartManager?.unsetSearchParamsMethod(setSearchParams);
        }
    }, [setSearchParams])
    const contextValue = useMemo(
        () => ({ searchParams, setSearchParams }),
        [searchParams, setSearchParams]
    )
    return (
        <SearchParamsContext.Provider value={contextValue}>
            {children}
        </SearchParamsContext.Provider>
    )
}